// The single company this app tracks boxes for.
export const DEFAULT_COMPANY_NAME = "Matsentralen";

// Inventory places. Warehouse and Kitchen plus the stores, which go by short
// names so the filter row and the picker stay compact. Shared by the server
// (validation) and the app (buttons) — add a store here and it shows up everywhere.
export const INVENTORY_LOCATIONS = [
  { value: "warehouse", label: "Warehouse", store: false },
  { value: "kitchen", label: "Kitchen", store: false },
  { value: "b", label: "B", store: true },
  { value: "l", label: "L", store: true },
  { value: "st", label: "ST", store: true },
  { value: "s", label: "S", store: true },
  { value: "so", label: "SØ", store: true },
] as const;
export type InventoryLocation = (typeof INVENTORY_LOCATIONS)[number]["value"];
export const isInventoryLocation = (value: unknown): value is InventoryLocation =>
  INVENTORY_LOCATIONS.some((l) => l.value === value);
export const inventoryLocationLabel = (value: string) =>
  INVENTORY_LOCATIONS.find((l) => l.value === value)?.label ?? value;
